import type {
  NonRelatedDocuments,
  RelatedDocuments,
} from '../types/admin-documents-type'
import { api } from '@/lib/axios-client'

export const getRelatedDocuments = async function (
  permitSubmittalId: string,
): Promise<RelatedDocuments[] | null> {
  const data = await api.get<RelatedDocuments[]>(
    `/AIDocumentComparison/Id?permitSubmittalId=${permitSubmittalId}`,
  )
  if (!data) return null
  return data
}

export const getNonRelatedDocuments = async function (
  permitSubmittalId: string,
): Promise<NonRelatedDocuments[] | null> {
  const data = await api.get<NonRelatedDocuments[]>(
    `/AIDocumentComparison/PermitSubmittalId?permitSubmittalId=${permitSubmittalId}`,
  )
  if (!data) return null
  return data
}
